import { render } from "./ShowLabBooking.vue?vue&type=template&id=1b1d234b&scoped=true"
import script from "./ShowLabBooking.vue?vue&type=script&lang=js"
export * from "./ShowLabBooking.vue?vue&type=script&lang=js"

import "./ShowLabBooking.vue?vue&type=style&index=0&id=1b1d234b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1d234b"]])

export default __exports__